module.exports = __webpack_public_path__ + "img/white.68ec4e76.png";